module.exports = __webpack_public_path__ + "static/media/Lora.337fa370.ttf";